import * as dayjs from 'dayjs';
import { Dayjs } from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const VIEW_DATE_FORMAT = 'DD.MM.YYYY';
const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export const MAX_PRENATAL_DATE_OF_BIRTH: Dayjs = dayjs().add(1, 'day').add(40, 'weeks');
export const MIN_DATE_OF_BIRTH: Dayjs = dayjs().subtract(150, 'year');

export class DateService {
  public static formatDateForView(date: string): string {
    if (!date) {
      return '';
    }
    return dayjs(date, ISO_DATE_FORMAT).format(VIEW_DATE_FORMAT);
  }

  public static parseDateFromView(date: string): string {
    if (!date) {
      return '';
    }
    return dayjs(date, VIEW_DATE_FORMAT).format(ISO_DATE_FORMAT);
  }

  public static isChildAtOfferBegin(birthday: string, offerBegin: string): boolean {
    return dayjs(offerBegin).diff(birthday, 'year') < 18;
  }

  public static needsAdultFranchise(birthday: string, offerBegin: string): boolean {
    return dayjs(offerBegin).get('year') - dayjs(birthday).get('year') > 18;
  }

  public static isAdult(birthday: string): boolean {
    return dayjs().diff(birthday, 'year') >= 18;
  }

  public static isValidViewDate(date: string): boolean {
    return dayjs(date, VIEW_DATE_FORMAT, true).isValid();
  }

  public static isInFuture(date: string): boolean {
    return dayjs(date, ISO_DATE_FORMAT).isAfter(dayjs(), 'day');
  }

  public static isAfterMaxPrenatalBirthdate(date: string): boolean {
    // using local MAX_PRENATAL_DATE_OF_BIRTH because in tests export const with dayjs is not working.
    const MAX_PRENATAL_DATE_OF_BIRTH_LOCAL: Dayjs = dayjs().add(1, 'day').add(40, 'weeks');
    return dayjs(date, ISO_DATE_FORMAT).isAfter(MAX_PRENATAL_DATE_OF_BIRTH_LOCAL, 'day');
  }

  public static isOver150YearsAgo(date: string): boolean {
    // using local MIN_DATE_OF_BIRTH because in tests export const with dayjs is not working
    const MIN_DATE_OF_BIRTH_LOCAL: Dayjs = dayjs().subtract(150, 'year');
    return dayjs(date, ISO_DATE_FORMAT).isBefore(MIN_DATE_OF_BIRTH_LOCAL);
  }
}
